export default class NgRut {

    constructor() {
        this.restrict = 'A';
        this.require = 'ngModel';
    }

    link(scope, elem, attr, ctrl) {

        var Fn={
            validaRut : function (rutCompleto) {
                if (!/^[0-9]+-[0-9kK]{1}$/.test( rutCompleto )) return false;
                var tmp = rutCompleto.split('-');

                return (Fn.dv(tmp[0])) == tmp[1].toLowerCase();
            },
            dv : function(T){
                var M=0,S=1;
                for(;T;T=Math.floor(T/10))
                    S=(S+T%10*(9-M++%6))%11;
                return S?S-1:'k';
            }
        };
        scope.$watch(attr.ngModel, function(value) {
            if (value=='') return;

            if (!Fn.validaRut(value)) {
                ctrl.$rutValido=false;
                ctrl.$setValidity('rutValido',false);

            } else {
                ctrl.$setValidity('rutValido',true);
            }
        });


    }

    static create() {
        return new NgRut();
    }
}


// WEBPACK FOOTER //
// ./app/js/directives/ngRut.js